document.addEventListener('turbolinks:load', function () {
  $('.block_exit_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.block_exit_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.block_exit_slidedown_btn').fadeIn(0));
  });

  $('.block_exit_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.block_exit_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.block_exit_slideup_btn').fadeIn(0));
  });
  // ------------------------------------------------------------------------------------------------
  // 離脱防止分析
  // ------------------------------------------------------------------------------------------------
  function block_exit_update_url() {
    const block_exit_id = $('#block_exit_select_box option:selected').val();
    const gf = $('#block_exit_graph_pattern_select_input').val();
    // const ab = $('#block_exit_ab_test_select_box option:selected').val();
    const device = $('.block_exit_device_select').data("device");
    const start_day = $('#block_exit_report_start_day').val();
    const end_day = $('#block_exit_report_end_day').val();

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (block_exit_id !== 'none' && block_exit_id !== null && block_exit_id !== undefined) {
      params.set('block_exit_id', block_exit_id);
    } else {
      params.delete('block_exit_id');
    }

    // if (ab !== 'none' && ab !== null && ab !== undefined) {
    //   params.set('ab', ab);
    // } else {
    //   params.delete('ab');
    // }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == "0" || device == "1") {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // 離脱防止の選択
  // #################################################################
  $('#block_exit_select_box').on('change', function () {
    block_exit_update_url();
  });

  // #################################################################
  // ABテストの選択
  // #################################################################
  // $('#block_exit_ab_test_select_box').on('change', function () {
  //   block_exit_update_url();
  // });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.block_exit_graph_pattern_select_day, .block_exit_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#block_exit_graph_pattern_select_input').val(gf_value);
    block_exit_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.block_exit_device_select_all, .block_exit_device_select_pc, .block_exit_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.block_exit_device_select').data("device", device);
    block_exit_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#block_exit_report_start_day, #block_exit_report_end_day').on('change', function () {
    block_exit_update_url();
  });

  // #################################################################
  // 表の年月切り替え
  // #################################################################
  $('#ua_block_exit_month_selects').on('change', function () {
    let block_exit_id = $('#block_exit_select_box option:selected').val();
    let month = $('#ua_block_exit_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      // location.href = 'ugc_analysis';
    }
  });

  // #################################################################
  // 離脱防止のログデータのみの削除
  // #################################################################
  $('.delete_block_exit_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const block_exit_id = $('#block_exit_select_box option:selected').val();

    $.ajax({
      url: '/block_exit_report/delete_block_exit_log',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 離脱防止のログデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_block_exit_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const block_exit_id = $('#block_exit_select_box option:selected').val();

    $.ajax({
      url: '/block_exit_report/delete_block_exit_log_and_related_data',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.href = '/index';
      }
    });
  });

  // #################################################################
  // 離脱防止のレポートのcsv出力
  // #################################################################
  $('#download_block_exit_csv').on('click', function () {
    const block_exit_id = $('#block_exit_select_box option:selected').val();
    const month = $('#ua_block_exit_month_selects option:selected').val();
    const device = $('.block_exit_device_select').data('device');

    let href = '/download_block_exit_csv';

    href += `?block_exit_id=${block_exit_id}`;
    href += `&m=${month}`;
    href += `&device=${device}`;
    location.href = href;
  });

  // ------------------------------------------------------------------------------------------------
  // 離脱防止管理
  // ------------------------------------------------------------------------------------------------
  // #################################################################
  // 離脱防止管理の新規作成
  // #################################################################
  $('#block_exit_create').on('click', function () {
    const name = $('.block_exit_input').val();

    if (!name) {
      alert('名称を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/create_block_exit',
      type: 'POST',
      data: {
        name: name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.href = `/block_exit/index?block_exit_id=${data.block_exit_id}&block_exit_setting_id=${data.block_exit_setting_id}&device=${data.is_device}`;
      }
    });
  });

  // #################################################################
  // 離脱防止名の編集
  // #################################################################
  $('#block_exit_name_edit_btn').on('click', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    let name = $('.block_exit_name_val').val();

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_block_exit_name',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
        name: name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 離脱防止管理の切り替え
  // #################################################################
  $('.block_exit_selects').on('change', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    if (block_exit_id == 'new') {
      $('.block_exit_set_wrapper_display').css('display', 'block');
      $('.block_exit_device_setting_wrapper').css('display', 'none');
      $('.block_exit_show_valid_setting_wrapper').css('display', 'none');
      $('.block_exit_url_setting_wrapper').css('display', 'none');
      $('.block_exit_preview_setting_wrapper').css('display', 'none');
      $('.block_exit_preview_url_list_wrapper').css('display', 'none');
      $('.block_exit_preview_position_setting_wrapper').css('display', 'none');
      $('.block_exit_contents_setting_wrapper').css('display', 'none');
      $('.block_exit_name_setting_wrapper').css('display', 'none');
      $('.block_exit_excluded_url_setting_wrapper').css('display', 'none');
      $('.block_exit_delete_setting_wrapper').css('display', 'none');
      $('.block_exit_out_domain_setting_wrapper').css('display', 'none');
    } else {
      location.href = `/block_exit/index?block_exit_id=${block_exit_id}`;
    }
  });

  // #################################################################
  // ポップアップのデバイスの切り替え
  // #################################################################
  $('.block_exit_device_selects').on('change', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    let block_exit_setting_id = $('.block_exit_device_selects:checked').data("block_exit_setting_id");

    location.href = `/block_exit/index?block_exit_id=${block_exit_id}&block_exit_setting_id=${block_exit_setting_id}`;
  });

  // #################################################################
  // 離脱防止の表示URL設定
  // #################################################################
  $('#block_exit_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="block_exit_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="block_exit_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.block_exit_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.block_exit_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#block_exit_url_set').on('click', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    let urls = [];
    $('.block_exit_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_block_exit_url',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // 離脱防止の除外URL設定
  // #################################################################
  $('#block_exit_excluded_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="block_exit_excluded_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="block_exit_excluded_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.block_exit_excluded_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.block_exit_excluded_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#block_exit_excluded_url_set').on('click', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    let urls = [];
    $('.block_exit_excluded_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_block_exit_excluded_url',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // 離脱防止とコンテンツの連携
  // #################################################################
  $('.block_exit_contents_select_box').on('change', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    let block_exit_setting_id = $('.block_exit_device_selects:checked').data("block_exit_setting_id");
    let content_id = $(this).val();
    $.ajax({
      url: '/save_block_exit_content_id',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
        block_exit_setting_id: block_exit_setting_id,
        content_id: content_id
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // 離脱防止のプレビュー作成
  // #################################################################
  $('#block_exit_create_preview_btn')
    .off()
    .on('click', function () {
      $('.loadding').css('display', 'block');
      let block_exit_id = $('.block_exit_selects option:selected').val();
      let is_device = $('.block_exit_device_selects:checked').val();
      let block_exit_setting_id = $('.block_exit_device_selects:checked').data("block_exit_setting_id");
      let preview_url = $('#block_exit_create_preview_url').val();
      if (block_exit_id == '' || block_exit_id == null || preview_url == '') {
        $('.loadding').css('display', 'none');
        alert('必須項目を入力してください。');
        return;
      }

      $.ajax({
        url: '/block_exit/save_block_exit_preview',
        type: 'POST',
        data: {
          block_exit_id: block_exit_id,
          is_device: is_device,
          block_exit_setting_id: block_exit_setting_id,
          url: preview_url
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    });

  // #################################################################
  // 離脱防止のプレビュー編集
  // #################################################################
  $('.create_block_exit_preview_html_edit').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/edit_block_exit_preview_html',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        // モーダルを作成し、HTMLコンテンツとボタンを表示
        let modalHtml = `<div id="html_modal_wrapper"></div>
                        <div id="html_modal_container" class="fixed p-5 top-[2.5%] left-1/2 transform -translate-x-1/2 w-90per h-90per overflow-auto text-center bg-white dark:text-gray-500 dark:bg-gray-900 dark:border-b dark:border-black">
                          <div class="border border-gray-200 h-90per mb-4">
                            <textarea id="html_modal_text_area" class="p-2 h-full w-full"></textarea>
                          </div>
                          <div class="flex justify-center">
                            <div id="html_remove_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-gray-500 hover:bg-gray-700 dark:hover:bg-gray-600 dark:bg-gray-800 dark:text-gray-500">閉じる</div>
                            <div id="html_save_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-base-800 hover:bg-base-800 ml-2 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500">保存</div>
                          </div>
                        </div>`;

        // モーダルをbody要素に追加
        $('body').append(modalHtml);
        $('#html_modal_text_area').text(data.html_content);

        $('#html_save_btn').on('click', function () {
          let html = $('#html_modal_text_area').val();
          $.ajax({
            url: '/update_block_exit_preview_html',
            type: 'POST',
            data: {
              id: preview_id,
              url: preview_url,
              html: html,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              location.reload();
            }
          });
        });

        $('#html_modal_wrapper, #html_remove_btn').on('click', function (e) {
          $('#html_modal_wrapper, #html_modal_container, #html_modal_text_area, #html_save_btn').remove();
        });
      }
    });
  });

  // #################################################################
  // 離脱防止のプレビュー削除
  // #################################################################
  $('.create_block_exit_preview_url_delete').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/delete_block_exit_preview',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 離脱防止の公開設定
  // #################################################################
  $('.block_exit_show_valid_select_box').on('change', function (event) {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    let block_exit_setting_id = $('.block_exit_device_selects:checked').data("block_exit_setting_id");
    let show_valid = $('.block_exit_show_valid_select_box:checked').val();
    $.ajax({
      url: '/save_block_exit_show_valid',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
        block_exit_setting_id: block_exit_setting_id,
        show_valid: show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 離脱防止のサイト外に飛ぶ時の設定
  // #################################################################
  $('.block_exit_out_domain_flag').on('change', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();
    let block_exit_setting_id = $('.block_exit_device_selects:checked').data("block_exit_setting_id");
    let out_domain_flag = 0;
    if ($('.block_exit_out_domain_flag').is(':checked')) {
      out_domain_flag = 1;
    }

    $.ajax({
      url: '/save_block_exit_out_domain_flag',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
        block_exit_setting_id: block_exit_setting_id,
        out_domain_flag: out_domain_flag
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 離脱防止施策削除
  // #################################################################
  $('#block_exit_delete_btn').on('click', function () {
    let block_exit_id = $('.block_exit_selects option:selected').val();

    if (!confirm('完全に削除され復元することはできません。本当に削除しますか？')) {
      return;
    }

    $.ajax({
      url: '/block_exit/delete_block_exit',
      type: 'POST',
      data: {
        block_exit_id: block_exit_id,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('離脱防止施策を削除しました。');
      location.href = `/block_exit/index`;
    });
  });
});
